/* PLAKTON · pk-cart.js — «Completa tu look» en la cesta lateral */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var fmt; try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: cur }); } catch (e) { fmt = { format: function (n) { return n + ' €'; } }; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var cache = {};

  function load(box) {
    if (box.dataset.loaded) return;
    box.dataset.loaded = '1';
    var id = box.getAttribute('data-product-id');
    if (!id) return;
    var ex = (box.getAttribute('data-exclude') || '').split(',');
    var p = cache[id] || (cache[id] = fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=8&intent=related').then(function (r) { return r.json(); }));
    p.then(function (d) {
      var list = ((d && d.products) || []).filter(function (x) { return ex.indexOf(String(x.id)) === -1 && x.available; }).slice(0, 6);
      if (!list.length) return;
      var track = box.querySelector('[data-pk-recs-track]');
      track.innerHTML = list.map(function (x) {
        var price = x.price / 100, cmp = (x.compare_at_price || 0) / 100;
        return '<a class="pk-cart-recs__card" href="' + esc(x.url) + '">' +
          '<span class="pk-cart-recs__img">' + (x.featured_image ? '<img src="' + esc(img(x.featured_image, 240)) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</span>' +
          '<span class="pk-cart-recs__name">' + esc(x.title) + '</span>' +
          '<span class="pk-cart-recs__price' + (cmp > price ? ' is-sale' : '') + '">' + fmt.format(price) + '</span></a>';
      }).join('');
      box.hidden = false;
    }).catch(function () {});
  }

  function scan() { document.querySelectorAll('[data-pk-recs]:not([data-loaded])').forEach(load); }
  var side = document.getElementById('halo-cart-sidebar');
  if (side && 'MutationObserver' in window) new MutationObserver(scan).observe(side, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
